export const templateOfAudioBlock = `
    <div class="row content-block">
        <div class="col-12 column px-8 py-4">
            <audio-component color="accent" type="block2"></audio-component>
        </div>
    </div>
`
